import { register, init, getLocaleFromNavigator } from 'svelte-i18n';
import { getParamsVisualTest } from './etc/utils';

register('en', () => import('../public/locales/en.json'));
// register('pt', () => import('../public/locales/pt.json'));

let initialLocale = getLocaleFromNavigator();

const { enabled, lang } = getParamsVisualTest();

if (enabled) {
  initialLocale = lang || getLocaleFromNavigator();
}

init({
  fallbackLocale: 'en',
  initialLocale: 'en'
});

export function replaceVariables(text, vars) {
  if (!vars) return text;

  // Replace any passed in variables in the translation string.
  Object.keys(vars).map(k => {
    const regex = new RegExp(`{${k}}`, 'g');
    const regexWithSpace = new RegExp(`{ ${k} }`, 'g');
    text = text.replace(regex, vars[k]);
    text = text.replace(regexWithSpace, vars[k]);
  });

  return text;
}
